import React, {Component} from 'react';
import {Button} from '@betareader/design-system';
import {ManuscriptDisclosure} from '../../../../components/ai/DisclosureControls';
import {push} from '../../../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {updateSpineIndex} from '../../../../modules/readerApp';
import {updateJoinBetaRequest} from '../../../../modules/book';
import {getFreshIdToken} from '../../../../utils/authUtil';
import imageUtil from '../../../../utils/imageUtil';
import sanitizeHtml from '../../../../utils/sanitizeHtmlUtil';

const formattedHtml = value => ({
  __html: sanitizeHtml(value.replace(/\n/g, '<br />'))
});

export class Cover extends Component {
  componentDidMount() {
    this.props.percentagePassedUpdated({top: 0, bottom: 0});
  }

  acceptInvitationAndGoToBook = async () => {
    const idToken = await getFreshIdToken();
    const {currentBook} = this.props;
    this.props.updateJoinBetaRequest(idToken, currentBook.id, {status: 'ACCEPTED'}, succeeded => {
      if (succeeded) this.moveForward();
    });
  };

  moveForward = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const {currentBook, currentSpineIndex, updateSpineIndex} = this.props;
    if (currentSpineIndex >= currentBook.parts.length - 1) return;
    updateSpineIndex(currentSpineIndex + 1);
    window.scrollTo(0, 0);
  };

  render() {
    const {t, user, currentBook, cover} = this.props;
    const isAuthor = currentBook.author._id === user.uid;
    const startReading = !isAuthor && currentBook.readerStatus === 'APPROVED'
      ? this.acceptInvitationAndGoToBook : this.moveForward;
    const coverUrl = imageUtil.getImageUrl({
      operation: 'width', size: 500, originalImageUrl: cover.highRes.url
    });

    return (
      <main style={{maxWidth: 1100, margin: '0 auto', padding: '1.5rem'}}>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: '2rem', alignItems: 'center'}}>
          <div style={{textAlign: 'center'}}>
            <img src={coverUrl} alt={`${currentBook.title} ${t('Cover')}`}
              style={{maxWidth: '100%', maxHeight: 'calc(100vh - 100px)', objectFit: 'contain'}} />
          </div>
          <div className='br-text'>
            <h1>{currentBook.title}</h1>
            <p>{`${t('by')} ${currentBook.authorName}`}</p>
            <ManuscriptDisclosure book={currentBook} details />
            <section aria-labelledby='reader-cover-description'>
              <h2 id='reader-cover-description'>{t('Description')}</h2>
              {currentBook.description && (
                <div dangerouslySetInnerHTML={formattedHtml(currentBook.description)} />
              )}
            </section>
            <section aria-labelledby='reader-cover-genres'>
              <h2 id='reader-cover-genres'>{t('Genres')}</h2>
              <ul style={{display: 'flex', flexWrap: 'wrap', gap: '.5rem', padding: 0, listStyle: 'none'}}>
                {currentBook.genres?.map(genre => (
                  <li key={genre} style={{border: '1px solid currentColor', borderRadius: 999, padding: '.25rem .6rem'}}>
                    {genre}
                  </li>
                ))}
              </ul>
            </section>
            <section aria-labelledby='reader-cover-guidelines'>
              <h2 id='reader-cover-guidelines'>{t('Feedback guidelines')}</h2>
              {currentBook.feedbackGuidelines && (
                <div dangerouslySetInnerHTML={formattedHtml(currentBook.feedbackGuidelines)} />
              )}
            </section>
            {currentBook.copyRightInfo && (
              <section aria-labelledby='reader-cover-copyright'>
                <h2 id='reader-cover-copyright'>{t('CopyrightInfo')}</h2>
                <div dangerouslySetInnerHTML={formattedHtml(currentBook.copyRightInfo)} />
              </section>
            )}
            <Button onClick={startReading}>{t('StartReading')} →</Button>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  currentSpineIndex: state.readerApp.currentSpineIndex,
  currentLanguage: state.user.currentLanguage
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateSpineIndex,
  updateJoinBetaRequest,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Cover)));
